import React from 'react';

// https://coderwall.com/p/i817wa/one-line-function-to-detect-mobile-devices-with-javascript
// ... don't use mobile detection unless you ABSOLUTELY HAVE to

const isMobile =
  (typeof window.orientation !== 'undefined') ||
  (navigator.userAgent.indexOf('IEMobile') !== -1);

export default isMobile;

const MOBILE_MAX_WIDTH_PX = 640;

export function useIsMobileWindowWidth() {
  const [windowWidth, setWindowWidth] = React.useState(undefined);

  React.useEffect(() => {
    function handleResize() {
      setWindowWidth(window?.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth <= MOBILE_MAX_WIDTH_PX;
}
